var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Icons from '../../../icons';
import { CustomCarousel } from './carousel.styles';
import { baseImgURL } from '../../../network/api-config';
export var Carousel = function (_a) {
    var thumbs = _a.thumbs, selectedImage = _a.selectedImage, onChange = _a.onChange, children = _a.children;
    var ArrowPrev = function (_a) {
        var onClick = _a.onClick, onKeyDown = _a.onKeyDown, visible = _a.visible;
        return (visible ? (_jsx("button", __assign({ className: 'arrow-prev', onClick: onClick, onKeyDown: onKeyDown, tabIndex: 0, style: { position: 'absolute', zIndex: 2, bottom: 0, right: 75, background: 'none', border: 'none', cursor: 'pointer' } }, { children: _jsx("img", { src: Icons.arrowPrev, alt: "Previous" }) }))) : _jsx("button", __assign({ className: 'arrow-prev', tabIndex: 0, style: { position: 'absolute', zIndex: 2, bottom: 0, right: 75, background: 'none', border: 'none' } }, { children: _jsx("img", { src: Icons.arrowPrevInactive, alt: "Previous" }) })));
    };
    var ArrowNext = function (_a) {
        var onClick = _a.onClick, onKeyDown = _a.onKeyDown, visible = _a.visible;
        return (visible ? (_jsx("button", __assign({ className: 'arrow-right', onClick: onClick, onKeyDown: onKeyDown, tabIndex: 0, style: { position: 'absolute', zIndex: 2, bottom: 0, right: 20, background: 'none', border: 'none', cursor: 'pointer' } }, { children: _jsx("img", { src: Icons.arrowNext, alt: "Next" }) }))) :
            _jsx("button", __assign({ className: 'arrow-right', onClick: onClick, onKeyDown: onKeyDown, tabIndex: 0, style: { position: 'absolute', zIndex: 2, bottom: 0, right: 20, background: 'none', border: 'none', cursor: 'pointer' } }, { children: _jsx("img", { src: Icons.arrowNextInactive, alt: "Next" }) })));
    };
    var renderThumbs = function () {
        return thumbs.map(function (thumb, index) { return (_jsx("img", { src: (thumb === null || thumb === void 0 ? void 0 : thumb.image) ? "".concat(baseImgURL, "/").concat(thumb === null || thumb === void 0 ? void 0 : thumb.image) : "".concat(thumb), alt: "Thumbnail ".concat(index) }, index)); });
    };
    useEffect(function () {
        var handleKeyDown = function (event) {
            if (event.key === 'ArrowLeft') {
                var arrowPrev = document.querySelector('.arrow-prev');
                if (arrowPrev) {
                    arrowPrev.click();
                }
            }
            else if (event.key === 'ArrowRight') {
                var arrowRight = document.querySelector('.arrow-right');
                if (arrowRight) {
                    arrowRight.click();
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (_jsx(CustomCarousel, __assign({ showIndicators: false, thumbWidth: 100, selectedItem: selectedImage, renderThumbs: renderThumbs, renderArrowPrev: function (clickHandler, hasPrev) {
            return _jsx(ArrowPrev, { onClick: clickHandler, onKeyDown: function (event) { return event.key === 'ArrowLeft' && clickHandler(); }, visible: hasPrev });
        }, renderArrowNext: function (clickHandler, hasNext) {
            return _jsx(ArrowNext, { onClick: clickHandler, onKeyDown: function (event) { return event.key === 'ArrowRight' && clickHandler(); }, visible: hasNext });
        }, onChange: onChange }, { children: children })));
};
